if (!customElements.get('dc-product-details')) {
  class DcProductDetails extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-tabs') || this._isConnected) {
        return;
      }

      this._isConnected = true;
      this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this._onClick = this._handleClick.bind(this);
      this._onKeydown = this._handleKeydown.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      if (!this._isConnected) {
        return;
      }

      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
      this._isConnected = false;
    }

    _handleClick(event) {
      const tab = event.target.closest('[role="tab"]');

      if (!tab || !this.contains(tab)) {
        return;
      }

      this._activateTab(tab, false);
    }

    _handleKeydown(event) {
      const tab = event.target.closest('[role="tab"]');

      if (!tab || !this.contains(tab)) {
        return;
      }

      const currentIndex = this._tabs.indexOf(tab);
      let nextIndex = currentIndex;
      const isRtl = document.documentElement.dir === 'rtl';

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + (isRtl ? -1 : 1) + this._tabs.length) % this._tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex + (isRtl ? 1 : -1) + this._tabs.length) % this._tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this._tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this._activateTab(this._tabs[nextIndex], true);
    }

    _activateTab(activeTab, moveFocus) {
      this._tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);

        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;

        if (panel) {
          panel.hidden = !isActive;
        }
      });

      if (moveFocus) {
        activeTab.focus();
      }
    }
  }

  customElements.define('dc-product-details', DcProductDetails);
}
